import { findMaxDistance } from "./findMaxDistance";

export const calculateZoom = (polygons) => {
  const distanceMultiplier = 0.3;

  return 15 - findMaxDistance(polygons) * distanceMultiplier;
};
